import React, { PropsWithChildren, useState } from "react";
import { Popover } from "@bloomberg/media-ui-overlay";
import type { PopoverProps } from "@bloomberg/media-ui-overlay/dist/Popover";
import BetaIcon from "~components/SnapshotCharts/BetaIcon";
import { usePaywallAction } from "~hooks/usePaywallAction";

type BetaPopoverProps = Pick<
  PopoverProps,
  "allowedPlacements" | "eyebrow" | "text" | "Icon"
> & {
  localStorageKey: string;
  className?: string;
};

export default function BetaPopover(
  props: PropsWithChildren<BetaPopoverProps>
) {
  const {
    eyebrow,
    text,
    Icon,
    className,
    children,
    allowedPlacements,
    localStorageKey,
  } = props;
  const { shouldWallAction } = usePaywallAction();
  const [element, setElement] = useState<Element | null>(null);

  const closeTooltip = () => localStorage.setItem(localStorageKey, "true");

  const hasSeenPopover = localStorage.getItem(localStorageKey) === "true";

  const shouldShowPopOver = !hasSeenPopover && !shouldWallAction;

  return (
    <>
      <div className={className} ref={setElement}>
        {children || <BetaIcon />}
      </div>
      {shouldShowPopOver && (
        <Popover
          allowedPlacements={allowedPlacements}
          eyebrow={eyebrow}
          text={text}
          Icon={Icon}
          anchorElement={element}
          onDismiss={closeTooltip}
          acceptZeroDimensionAnchors
        />
      )}
    </>
  );
}
